import styled, { css } from 'styled-components';
export const NavigationItemStyled = styled.li `
  position: relative;
  color: ${({ theme }) => theme.ColorThemeTextHeaderLink};
  list-style: none;
  padding: 0;
  margin: 0;
  flex: 1;

  ${({ isChild, highlight, menuItems, isMobile }) => !isChild &&
    !highlight &&
    !menuItems &&
    !isMobile &&
    css `
      &:after {
        content: '';
        position: absolute;
        display: block;
        left: 0;
        right: 0;
        width: 4px;
        height: 4px;
        border-radius: 4px;
        margin: 0 auto;
        bottom: -5px;
        background-color: currentColor;
        transition: width 50ms ease-in, opacity 50ms ease-in;
        opacity: 0;
        pointer-events: none;
        user-select: none;
      }

      &:hover {
        &:after {
          opacity: 1;
        }
      }

      &:active,
      &:focus {
        &:after {
          opacity: 1;
          width: 15px;
        }
      }
    `}
`;
//# sourceMappingURL=navigation-item.styles.js.map